import React, { useEffect, useState } from 'react'
import { getAllTopics } from '../../services/subjects/subjectTopics'
import { useParams } from 'react-router-dom';
import { getMCQPastPaperQuestion } from '../../services/subjects/pastPaperQuestion';
import { Button, Chip, CircularProgress, IconButton, InputAdornment, LinearProgress, OutlinedInput, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from '@mui/material';
import { Visibility, VisibilityOff, Save } from '@mui/icons-material';
import { isNumber } from 'lodash';
import { updateMcqQuestion } from '../../services/question/mcq';

function SetTopicsForPage() {

    const { paperId } = useParams();

    const [allTopics, setAllTopics] = useState([])
    const [loading, setLoading] = useState(false)
    const [questions, setQuestions] = useState([]);
    const [updatingQuestionTopic, setUpdatingQuestionTopic] = useState(false)
    const [topicIdMap, setTopicIdMap] = useState({})


    useEffect(() => {
      loadAllTopics();
    }, [])

    useEffect(() => {
      loadQuestions();
    }, [paperId]);
    

    const loadAllTopics = async () => {
        if(loading) return;
        try {
            setLoading(true)
            const {data, status} = await getAllTopics();
            if(status === 200){
                setAllTopics(data)
            }

        } catch (error) {
            console.log(error);
            setLoading(false)
        }finally {
            setLoading(false)
        }
    }

    
    
        const loadQuestions = async () => {
            try {
              const {data, status} = await getMCQPastPaperQuestion(paperId);
              if (status !== 200) {
                console.log("Failed to load questions");
                return;
              }
              const sortedQuestions = data.sort((a, b) => a.index - b.index);
              // console.log(response.data);
              setQuestions(sortedQuestions);
            } catch (error) {
              console.log(error);
            }
          };

      const isWholeNumber = (value) => {
        return /^[0-9]+$/.test(value);
      }

      const onAddTopicToQuestion = async (question, topicId) => {
        // console.log(`Adding topic id ${topicId} to question id ${question.id}`);
        // console.log(question)
        // console.log(question.question)
        // console.log(question.question.question)
        if(!isWholeNumber(topicId)){
            alert("Topic id must be a number " + topicId);
            return;
        }
        const topic = allTopics.find(t => t.id === Number(topicId));
        if(!topic){
            alert("Topic not found");
            return;
        }
        if(updatingQuestionTopic) return;
        try{
            setUpdatingQuestionTopic(true);
            const oldTopics = question.question.question.subjectTopics || [];
            console.log(oldTopics)
            const {data, status} =  await updateMcqQuestion(question.question.id, {
                question : {
                    subjectTopics: [...oldTopics, topic]
                }
            });
            if(status === 200){
                // console.log("Updated question topic: ", data);
                // Update the questions state
                setQuestions(questions.map(q => q.question.id === question.question.id ? {
                    ...q,
                    question: data
                } : q));

                setTopicIdMap({...topicIdMap, [question.question.id]: ''})

            }

        }catch(error){
            console.log(error);
        }finally{
            setUpdatingQuestionTopic(false);
        }
        // Implement the logic to add the topic to the question
      }

      const onRemoveTopicFromQuestion = async (row, topicId) => {
        console.log(`Removing topic id ${topicId} from question id ${row.question.id}`);
        if(updatingQuestionTopic) return;
        const topic = allTopics.find(t => t.id === Number(topicId));
        if(!topic){
            alert("Topic not found");
            return;
        }
        try{
            setUpdatingQuestionTopic(true);
            const oldTopics = row.question.question.subjectTopics || [];
            const newTopics = oldTopics.filter(t => t.id !== Number(topicId));
            const {data, status} =  await updateMcqQuestion(row.question.id, {
                question : {
                    subjectTopics: newTopics    
                }
            });
            if(status === 200){
                // console.log("Updated question topic: ", data);
                // Update the questions state
                setQuestions(questions.map(q => q.question.id === row.question.id ? {
                    ...q,
                    question: data
                } : q));
            }
        }catch(error){
            console.log(error);
        }finally{
            setUpdatingQuestionTopic(false);
        }
      }

  return (
    <div>
      <Typography variant="h2" sx={{ margin: "10px" }}>
        Questions for Paper no papers
      </Typography>
      <div>
       {updatingQuestionTopic || loading ? <LinearProgress color="success" /> : null}
      </div>
      <TableContainer sx={{ margin: "10px" }}>
        <Table>
          <TableBody>
            {questions.map((row, index) => (
              <TableRow key={index} className="print-row" style={{
                backgroundColor : index % 2 === 0 ? 'white' : '#a6e2f5ff'
              }} >
                <TableCell
                  //  size='25px'
                  style={{ width: 2 }}
                  sx={{
                    // width: "25px",
                    borderWidth: "1px",
                    borderColor: "black",
                    borderStyle: "dashed",
                  }}
                >
                  {row.index}
                </TableCell>
                {/* <TableCell
                  //  size='25px'
                  style={{ width: 2 }}
                  sx={{
                    // width: "25px",
                    borderWidth: "1px",
                    borderColor: "black",
                    borderStyle: "dashed",
                  }}
                >
                  {row.id}
                </TableCell> */}
                <TableCell
                  // size='small'
                  style={{ width: 200 }}
                  sx={{
                    // width: "500px",
                    // flex : 1,
                    borderWidth: "1px",
                    borderColor: "black",
                    borderStyle: "dashed",
                  }}
                >
                  {
                    <span
                      dangerouslySetInnerHTML={{
                        __html: row.question.question.questionText,
                      }}
                    ></span>
                  }
                </TableCell>
                <TableCell
                  style={{ width: 100 }}
                  // size='small'
                  sx={{
                    // width: "25px",
                    color: "red",
                    borderWidth: "1px",
                    borderColor: "black",
                    borderStyle: "dashed",
                  }}
                >
                  {row.question.question.subjectTopics.map((topic) => (
                    <Chip
                      label={topic.name}
                      key={topic.id}
                      style={{ margin: "2px" }}
                      // variant="outlined"
                      onDelete={() => onRemoveTopicFromQuestion(row, topic.id)}
                    />
                  ))}
                </TableCell>

                <TableCell
                  style={{ width: 100 }}
                  // size='small'
                  sx={{
                    // width: "25px",
                    color: "red",
                    borderWidth: "1px",
                    borderColor: "black",
                    borderStyle: "dashed",
                  }}
                >
                  {/* <TextField id="outlined-basic" label="Topic id" variant="outlined" />
                  <Button variant='contained'>Primary</Button> */}

                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={'number'}
                    value={topicIdMap[row.question.id] || ''}
                    onChange={(e) => setTopicIdMap({...topicIdMap, [row.question.id]: e.target.value})}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => onAddTopicToQuestion(row, topicIdMap[row.question.id])}
                          edge="end"
                        >
                          {updatingQuestionTopic ? null: <Save />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Password"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default SetTopicsForPage